/*
 * @Description: 
 * @Author: 
 * @Date: 2022-07-22 15:51:12
 * @LastEditTime: 2022-07-22 17:39:09
 * @LastEditors: dongqianqian
 * @Usage: 
 */
export default {
  data: () => ({

  }),
  methods: {
    dialogCloseFun() {
      this.resetForm('ruleForm')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}